const parsePaymentValue = (value) => {
  if (typeof value === "number") {
    return value;
  }
  return parseInt(value.replace(/\s+/g, ""), 10);
};
export {
  parsePaymentValue
};
